import React from 'react';
import SlideLayout from '../layouts/SlideLayout';
import NumberedBadge from './NumberedBadge';
import { TwoColumnSlideProps } from '../types';
import '../styles/TwoColumnSlide.css';

const TwoColumnSlide: React.FC<TwoColumnSlideProps> = ({
  title,
  leftColumn,
  rightColumn,
  footer
}) => {
  return (
    <SlideLayout footer={footer} className="two-column-slide">
      <div className="two-column-content">
        {title && <h1 className="two-column-title">{title}</h1>}
        <div className="columns-wrapper">
        <div
          className={`column ${leftColumn.isDark ? 'column-dark' : ''}`}
          style={{ backgroundColor: leftColumn.backgroundColor || '#f5f5f5' }}
        >
          <h2 className="column-title">{leftColumn.title}</h2>
          {leftColumn.subtitle && (
            <p className="column-subtitle">{leftColumn.subtitle}</p>
          )}
          <div className="column-items">
            {leftColumn.items.map((item, index) => (
              <NumberedBadge key={index} number={item.number} text={item.text} isDark={leftColumn.isDark} />
            ))}
          </div>
        </div>

        <div
          className={`column ${rightColumn.isDark ? 'column-dark' : ''}`}
          style={{ backgroundColor: rightColumn.backgroundColor || '#ffffff' }}
        >
          <h2 className="column-title">{rightColumn.title}</h2>
          {rightColumn.subtitle && (
            <p className="column-subtitle">{rightColumn.subtitle}</p>
          )}
          <div className="column-items">
            {rightColumn.items.map((item, index) => (
              <NumberedBadge key={index} number={item.number} text={item.text} isDark={rightColumn.isDark} />
            ))}
          </div>
        </div>
        </div>
      </div>
    </SlideLayout>
  );
};

export default TwoColumnSlide;
